module.exports = __webpack_public_path__ + "static/img/icon-setPassword.885a90ca.png";